module.exports = __webpack_public_path__ + "img/heading-img.10c8eb4b.png";